import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs/operators';
import { Subject, Observable, of } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import * as fromBackStore from '@apps/back/store';
import { User } from '@apps/auth/domain/models/back';
import { Actions, ofType } from '@ngrx/effects';
import { BackAuthEntityUsersQsWordImpeSet, BackAuthEntityUsersSucceeded } from '@apps/back/store/auth/entities/global/entities-global.actions';
import { BackAuthUserSelectedSet } from '@apps/back/store/auth/users/global/users-global.actions';
import { DetailedUser } from '@apps/back/store/auth/users/users.common';

@Component({
    selector: 'aa-impe-users-list',
    templateUrl: './impe-users-list.component.html',
    styleUrls: [
        './impe-users-list.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImpeUsersListComponent implements OnInit, OnDestroy
{
    public users!: Observable<User[]>;
    private destroyator: Subject<boolean> = new Subject();
    public isEmpty: Observable<boolean> = of(false);

    constructor (
        private actions: Actions,
        private store: Store<IAuroraState>
    )
    { }

    ngOnInit ()
    {
        this.users = this.actions
            .pipe(
                ofType(BackAuthEntityUsersSucceeded),
                switchMap(() =>
                    this.store.select(fromBackStore.getPipelinedEntityUsersImpe)
                )
            );
        this.isEmpty = this.users
            .pipe(
                map((items: User[]) =>
                    items.length === 0
                )
            );
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(true);
        this.destroyator.complete();
    }

    onQsWordChanged (qsWordImpe: string)
    {
        this.store.dispatch(BackAuthEntityUsersQsWordImpeSet({ qsWordImpe }));
    }

    onSelect = (user: User): void =>
    {
        this.store.dispatch(
            BackAuthUserSelectedSet({ user: user as DetailedUser })
        );
    };
}
